import { APP_ROUTES } from "../constants";
import { isLinkUsageConsumed } from "./link-usage";

type FetchOperation = (
  linkId: string,
  operationId: string,
) => Promise<{ fundingMethod?: string }>;

export const CONSUMED_READONLY_PATHS = [
  APP_ROUTES.HOW_TO_DEPOSIT_CASH_PAGE,
  APP_ROUTES.STORES_MAP_PAGE,
] as const;

export function isConsumedReadonlyPath(pathname: string): boolean {
  return (CONSUMED_READONLY_PATHS as readonly string[]).includes(pathname);
}

export function isCashDepositOperation(op?: {
  fundingMethod?: string;
} | null): boolean {
  return (op?.fundingMethod ?? "").toUpperCase() === "CASH_DEPOSIT";
}

export function howToDepositCashRoute(operationId: string): string {
  return `${APP_ROUTES.HOW_TO_DEPOSIT_CASH_PAGE}?operationId=${encodeURIComponent(operationId)}`;
}

export function consumedResumePathFromOperation(
  operationId: string | undefined,
  operation: { fundingMethod?: string } | null,
): string {
  if (operationId && isCashDepositOperation(operation)) {
    return howToDepositCashRoute(operationId);
  }
  return APP_ROUTES.LINK_ALREADY_USED_PAGE;
}

export async function resolveConsumedResumePath(params: {
  linkId: string;
  operationId?: string;
  fetchOperation?: FetchOperation;
}): Promise<string> {
  const { linkId, operationId } = params;
  if (!operationId) {
    return APP_ROUTES.LINK_ALREADY_USED_PAGE;
  }
  try {
    const fetchOperation =
      params.fetchOperation ??
      (await import("../services/api")).getOperation;
    const operation = await fetchOperation(linkId, operationId);
    return consumedResumePathFromOperation(operationId, operation);
  } catch {
    return APP_ROUTES.LINK_ALREADY_USED_PAGE;
  }
}

/** Session config that already paid a single-use Lola link. */
export function consumedOperationId(config?: {
  usage?: { state?: string; operationId?: string };
} | null): string | undefined {
  if (!isLinkUsageConsumed(config)) return undefined;
  return config?.usage?.operationId;
}
